import ActionTypes from './constants';

const DEFAULT_STATE = { 
    trackOptions: [],
    selectedTrackItems: [],
    clicNums: ''
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case ActionTypes.SET_TRACK_OPTIONS : {
            return Object.assign({}, state, {
                trackOptions: [...action.trackOptions]
            });
        }
        case ActionTypes.SET_SELECTED_TRACK_ITEMS : {
            return Object.assign({}, state, {
                selectedTrackItems: [...action.selectedTrackItems]
            });
        }
        case ActionTypes.SET_CLIC_NUMS : {
            return Object.assign({}, state, {
                clicNums: action.clicNums
            });
        }
        default:
            return state;
    }
}